import ReactQuill from 'react-quill-new';

const Quill = ReactQuill.Quill;
const BubbleTheme = Quill.import('themes/bubble');

class GlassBubble extends BubbleTheme {}

Quill.register('themes/glass-bubble', GlassBubble, true);
